import React from 'react';

import { DescriptionList, DescriptionItem } from '@gogame/components';

const GeneralSectionOnDraft = ({ data, onOpenBusinessPartner }) => {
  return (
    <DescriptionList disableGutters={true} data={data} stripEmpty={true}>
      <DescriptionItem
        label={'Business partner'}
        field={'businessPartner'}
        type={'link'}
        linkLabelField={'name'}
        onValueClick={onOpenBusinessPartner}
        placeholder={'Not recognized'}
      />
    </DescriptionList>
  );
};

export default GeneralSectionOnDraft;
